import api from '../api'
import type { ExportStockReport } from './interface'

export const postStockReport = async (data: ExportStockReport) => {
  const response = await api.post(`services/inventory-management/v1/ExportarConsultarEstoque`, data)

  return response.data
}
